var _circle, _path, _circle2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWasher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.37 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "washer"
  }, "Washer Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "washer"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9,
    cy: 5.46,
    r: 2.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,16.47A12.16,12.16,0,1,1,6.86,28.62,12.16,12.16,0,0,1,19,16.47M19,15A13.66,13.66,0,1,0,32.67,28.62,13.66,13.66,0,0,0,19,15Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.83,
    cy: 5.46,
    r: 2.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.81.13H1.89A2.75,2.75,0,0,0-.86,2.88V45.35a2.59,2.59,0,0,0,2.59,2.59H35.81a2.59,2.59,0,0,0,2.59-2.59V2.72A2.59,2.59,0,0,0,35.81.13ZM1.89,1.63H35.81A1.09,1.09,0,0,1,36.9,2.72V9.55H.64V2.88A1.25,1.25,0,0,1,1.89,1.63ZM35.81,46.44H1.73A1.09,1.09,0,0,1,.64,45.35V11.05H36.9v34.3A1.09,1.09,0,0,1,35.81,46.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.44,3.92V7H5.07V3.92h9.37m0-1H5.07a1,1,0,0,0-1,1V7a1,1,0,0,0,1,1h9.37a1,1,0,0,0,1-1V3.92a1,1,0,0,0-1-1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19,18.5A10.11,10.11,0,1,0,29.06,28.6,10.1,10.1,0,0,0,19,18.5Zm0,1A9.1,9.1,0,0,1,28,28.19l-.11.08a7.19,7.19,0,0,1-2.53,1.95c-.33.07-.9-.5-1.36-.95a3.61,3.61,0,0,0-1.65-1.16c-.76-.14-1.36.48-1.94,1.08s-.94,1-1.42,1-1.05-.53-1.56-1.06-1.1-1.11-1.72-1a2.48,2.48,0,0,0-1.43,1A3.52,3.52,0,0,1,13,30.18c-.63.25-2.09-1-2.88-1.9a.53.53,0,0,0-.26-.15A9.11,9.11,0,0,1,19,19.5Zm0,18.21a9.12,9.12,0,0,1-9.06-8.22c.82.82,2.31,2.08,3.48,1.63a4.4,4.4,0,0,0,1.69-1.34c.3-.33.58-.65.8-.68s.61.48.88.75c.64.66,1.44,1.48,2.41,1.36a3.66,3.66,0,0,0,2-1.33c.36-.37.81-.82,1-.78a3.37,3.37,0,0,1,1.13.88c.62.61,1.26,1.25,2,1.25l.21,0A5.82,5.82,0,0,0,28,29.62,9.12,9.12,0,0,1,19,37.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasher);
export default __webpack_public_path__ + "static/media/washer.5ac818319bd2cc392e2c2719e6f02b00.svg";
export { ForwardRef as ReactComponent };